import "./SpecialDayOffAdminReportHeader.scss";
import { useTranslation } from "react-i18next";
import ReplayIcon from "@mui/icons-material/Replay";
import { useSdoAdminReportsProvider } from "../../providers/SdoAdminReportsProvider";
import { SdoPositionsPublishObj } from "../../models/SdoInterface";
import { useEffect, useState } from "react";
import { getDateInWeekDayMonthDateFormat } from "../../helpers/dateHelpers";
import { getLastPublishedDate } from "../SdoAdminReportDetails/SdoAdminReportHelper";
import { useProfile } from "../../providers/Profile";

export default function SpecialDayOffAdminReportHeader() {
  const { t } = useTranslation();
  const sdoAdminReportsContext = useSdoAdminReportsProvider();
  const [positionsPublishData, setPositionsPublishData] = useState<SdoPositionsPublishObj>();
  const getTwoDigits = (param) => param < 10 ? ('0' + param) : param;
  const profileContext = useProfile();
    const [profile,setProfile] = useState<any>();

  useEffect(() => {
    if (!sdoAdminReportsContext.sdoPositionsPublishData) return;
    setPositionsPublishData(sdoAdminReportsContext.sdoPositionsPublishData);
  }, [sdoAdminReportsContext.sdoPositionsPublishData]);
  
  useEffect(()=>{
    if(!profileContext?.profile?.results) return;
    setProfile(profileContext?.profile?.results);
},[profileContext.profile]);

  return (
    <div className="sdo-admin-header__container">
      <div className="sdo-admin-header__title">
        <div className="sdo-admin-header__title-text">
          <h1>{t("specialDayOffAdmin.specialDayOffAdminReportHeader.title")}</h1>
        </div>
        <span className="sdo-admin-header__updated-time">{t("specialDayOffAdmin.specialDayOffAdminReportHeader.lastUpdated")} {getDateInWeekDayMonthDateFormat(new Date(getLastPublishedDate(profile, positionsPublishData?.positions)))}  {getTwoDigits(new Date(getLastPublishedDate(profile, positionsPublishData?.positions)).getHours())}:{getTwoDigits(new Date(getLastPublishedDate(profile, positionsPublishData?.positions)).getMinutes())} ET</span>
      </div>
      <div className="reset-button-container" onClick={() => window.location.reload()}>
        <span className="reset-button-link">{t("specialDayOffAdmin.specialDayOffAdminReportHeader.refresh")}</span>
        <ReplayIcon viewBox="-4,0,24,24" fontSize="large" className="replay-con" />
      </div>
    </div>
  );
}
